import { h, Component } from 'preact';

import { sections } from 'pages/bolt_pages';

import Store from 'store/store';
import 'store/bolt/footer';
import { getCopy } from 'utils/copy';
import { smoothScrollTo } from 'utils/smoothScroll';
import { accessNested, joinClasses, sortObjectByOrder } from 'utils/utils';
import { getIsSinglePageIframed, hideFooter } from 'utils/bolt/client';
import { geoFromIP } from 'utils/bolt/geo';
import Link from 'components/bolt/link/link';
import Button from 'components/bolt/button/button';
import Close from 'components/bolt/icons/close';
import ArrowDown from 'components/bolt/icons/arrowDown';
import { SonyFooter } from 'pages/bolt_features';
import HTML from 'components/core/html/html.js';
import * as webp from 'utils/bolt/webp';

import s from 'components/bolt/footer/footer.sss';

const dom = el => el?.base || el;

let userRegion;
const getUserRegion = (() => {
	let promise;
	return (onCreate) => {
		if (!promise) {
			promise = geoFromIP();
			promise.then(onCreate);
		}
		return promise;
	};
})();

export default class Footer extends Component {
	constructor(props) {
		super(props);
		this.renderOpenFooter = this.renderOpenFooter.bind(this);
		this.toggleFooter = this.toggleFooter.bind(this);
		this.closeFooter = this.toggleFooter.bind(this, false);
		this.openFooter = this.toggleFooter.bind(this, true);
		this.getFallbackFormat = this.getFallbackFormat.bind(this);
		this.startAutoExpandTimer = this.startAutoExpandTimer.bind(this);
		this.stopAutoExpandTimer = this.stopAutoExpandTimer.bind(this);
		this.cancelAutoExpanding = this.cancelAutoExpanding.bind(this);
		this.onLinkClick = this.onLinkClick.bind(this);

		this.footerData = accessNested(props, 'data.defaultFooter', {});
		this.updateSticky(props);
		this.autoExpand = accessNested(props, 'data.defaultFooter.autoExpand', false);
		this.autoExpandDuration = accessNested(props, 'data.defaultFooter.autoExpandDuration', 3);
		let region = accessNested(props, 'store.appData.meta.region.slug');
		this.tealiumCookiesEnabled = region !== 'au' && accessNested(props, 'store.appData.options.enableTealium', false);
		this.ensightenTrackingEnabled = props.store?.appData?.options?.enableEnsighten;
		this.allowAutoExpand = accessNested(props, 'store.footer.allowAutoExpand', true);
		this.fontStyles = accessNested(props, 'store.appData.styling.fontVariables', {});
		this.showtimesFooter = props.parent === 'showtimes';
		this.pressKitFooter = props.parent === 'pressKit';
		this.hasTextPage = Object.values(accessNested(props, 'store.appData.pages', {})).find(e => e.component === 'text' || e.page === 'text');

		this.state = {
			open: false,
			autoExpanding: false,
			backgroundColor: null
		};
	}

	componentDidMount() {
		if (this.autoExpand && this.allowAutoExpand) {
			this.startAutoExpandTimer();
		}
		this.updateCoveredScreenSize();
	}

	componentWillReceiveProps(nextProps) {
		this.updateSticky(nextProps);
	}

	componentDidUpdate() {
		if (!this.props.parent) {
			const activePage = this.props.store.activePage;
			let lowestSection = activePage;
			if (activePage === 'boltHome' && sections) {
				lowestSection = sections[sections.length - 1]?.id;
			}
			try {
				let elem = lowestSection && document.querySelector(`[data-section="${lowestSection}"]`);
				let backgroundColor = elem && window.getComputedStyle(elem).backgroundColor;
				if (backgroundColor && this.state.backgroundColor !== backgroundColor) {
					this.setState({ backgroundColor });
				}
			} catch (e) {}
		} else if (!this.state.backgroundColor && this.props.fallBackColor) {
			this.setState({ backgroundColor: this.props.fallBackColor });
		}
		this.updateCoveredScreenSize();
	}

	updateSticky(props = this.props) {
		const activePage = props.store?.activePage;
		const activePageData = props.store?.appData?.pages?.[activePage]?.data;
		const position = activePageData?.footer?.position || props.data?.defaultFooter?.position || 'fixed';
		this.sticky = position === 'fixed';
	}

	updateCoveredScreenSize() {
		if (!this.$cta) {
			return;
		}
		let isMobile = this.props.store?.client?.deviceSize === 'mobile';
		let coveredScreenSize = isMobile && this.sticky ? dom(this.$cta).offsetHeight : 0;
		if (coveredScreenSize !== this.props.store.footer.coveredScreenSize) {
			Store.get().footer.set({ coveredScreenSize });
		}
	}

	startAutoExpandTimer() {
		this.setState({
			open: true,
			autoExpanding: true
		});

		const duration = this.autoExpandDuration * 1000;
		this.collapseTimer = window.setTimeout(() => {
			this.cancelAutoExpanding();
		}, duration);

	}

	stopAutoExpandTimer() {
		window.clearTimeout(this.collapseTimer);
	}

	cancelAutoExpanding() {
		this.setState({
			open: false,
			autoExpanding: false
		});
		this.stopAutoExpandTimer();
		Store.emit('FOOTER_AUTO_EXPANDED');
	}

	openEvidon() {
		window.evidon?.notice?.showPreferencesDialog();
	}
	onLinkClick() {}

	isLoneVideoDefaultFooter() {
		const defaultFooter = accessNested(this.props, 'data.defaultFooter');
		if (!defaultFooter) {
			return false;
		}
		const pages = Object.keys(accessNested(this.props, 'store.appData.pages', {}));
		const pageExceptions = ['boltVideos', 'bolt-toolkit', 'boltBanner', 'browser-not-supported', 'boltIframe'];
		const otherPages = pages.filter(id => !pageExceptions.includes(id));
		return (otherPages.length === 0);
	}


	toggleFooter(state) {
		const open = typeof state === 'boolean' ? state : !this.state.open;
		this.setState({ open });

		if (open && this.showtimesFooter) {
			const showtimesScroller = document.querySelector(`[data-section=scroller]`);
			const bottom = this.base.offsetTop + this.base.offsetHeight;
			smoothScrollTo(showtimesScroller, bottom, 300);
		}
	}

	renderOpenFooter() {
		const {
			logos,
			links,
			copyright
		} = this.footerData;

		const footerBgStyling = accessNested(Store.get(), 'appData.styling.variables.footerBgColor', this.state.backgroundColor);
		const accessibilityCopy = accessNested(Store.get(), 'appData.copy.accessibilityCopy', {});


		const autoExpanding = this.state.autoExpanding;

		const footerStyle = {
			background: !this.pressKitFooter && footerBgStyling
		};

		return (
			<div class={joinClasses(s.openWrapper, autoExpanding && s.autoExpanding)} style={footerStyle} role="contentinfo">
				<Button
					class={s.closeBtn}
					trigger={autoExpanding ? this.cancelAutoExpanding : this.toggleFooter}
					ariaLabel={accessibilityCopy.$COLLAPSE_FOOTER_ARIA}
				>
					<Close />
				</Button>
				<div class={joinClasses(s.studioDetails)}>
					{this.getLogos(logos)}
					<div class={s.line} />
					<ul class={s.links}>
						{this.renderLinks(links, 'link')}
					</ul>
				</div>
				<ul class={joinClasses(s.copyright, this.fontStyles.footerCopyright)}>
					{this.renderLinks(copyright, 'copyright')}
				</ul>
			</div>
		);
	}

	getLogos(logos) {
		if (!logos) {
			return;
		}
		return (
			<ul class={s.logos}>
				{this.renderLinks(logos, 'logo')}
			</ul>
		);
	}

	tealiumAction() {
		if (window.DisneyGDPR && window.DisneyGDPR.Core && typeof window.DisneyGDPR.Core.openPreferencesDialog === 'function') {
			window.DisneyGDPR.Core.openPreferencesDialog();
		}
	}

	ensightenAction(e) {
		if (typeof window.__dataLayer?.OneTrustDialog === 'function') {
			window.__dataLayer?.OneTrustDialog(e);
		}
	}

	getFallbackFormat() {
		return accessNested(this.props, 'appData.footer.alternativeImageFormat', 'png');
	}

	getLinkContent(link, type) {
		if (type === 'logo') {
			const fileImg = link.src;
			const fallbackFormat = this.getFallbackFormat();

			// TODO: get rid of webp.Picture (all browsers we care about support webp)
			return (
				<webp.Picture
					class={s.logo}
					src={fileImg}
					alt={getCopy(link.alt, {}, '', null, 'accessibilityCopy') || link.alt}
					fallbackFormat={fallbackFormat}
				/>
			);
		}

		const content = getCopy(link.$copy, {}, '', null, 'baseCopy') || link.$copy;
		if (type === 'copyright' || type === 'link') {
			return <HTML content={content} markdown />;
		}
		return content;
	}

	renderLinks(items, type) {
		const ageGateEnabled = accessNested(Store.get(), 'appData.options.ageGate', false);
		const isOfAge = accessNested(Store.get(), 'client.ofAge', null);
		items = sortObjectByOrder(items, (item, key) => ({ key, ...item })).filter(item => {
			const ageGateShowOnly = +item.ageGateShowOnly || 0;
			if (ageGateShowOnly) {
				// ageGateShowOnly = 1 : age over the limit only
				if (ageGateShowOnly === 1 && ageGateEnabled && !isOfAge) {
					return false;
				}
				// ageGateShowOnly = 2 : age under the limit only
				if (ageGateShowOnly === 2 && isOfAge) {
					return false;
				}
			}
			if ((item.excludeFromShowtimes && this.showtimesFooter) || (item.showtimesOnly && !this.showtimesFooter)) {
				return false;
			}
			if (item.userRegion) {
				// If we don't have the region yet, start getting it and then rerender once we have it
				getUserRegion(geo => {
					userRegion = geo?.countryCode;
					this.forceUpdate();
				});
				const valid = item.userRegion.split(',').map(r => r.trim().toLowerCase()).includes(userRegion);
				if (!valid) {
					return false;
				}
			}
			return true;
		});

		let links = [];

		const isAuRegion = __REGION__ === 'au' || __REGION__ === 'nz';

		if (type === 'link' && (this.tealiumCookiesEnabled || (this.ensightenTrackingEnabled && !isAuRegion))) {
			links.push(
				<li class={s[`${type}Wrapper`]} key="tealium">
					<Button
						class={joinClasses(s[`${type}Link`], this.fontStyles.footerLegalLinks)}
						trigger={this.ensightenTrackingEnabled ? this.ensightenAction : this.tealiumAction}
					>
						{accessNested(this.props, 'store.appData.copy.baseCopy.$COOKIE_SETTINGS') || 'Cookie Settings'}
					</Button>
				</li>
			);
		}

		return links.concat(items.map((item, key) => {
			let content = this.getLinkContent(item, type);

			if (item.url && item.url.startsWith('@')) {
				return (
					<li class={s[`${type}Wrapper`]} key={key}>
						<Button
							class={joinClasses(s[`${type}Link`], this.fontStyles[type === 'copyright' ? 'footerCopyright' : 'footerLegalLinks'])}
							trigger={() => Store.emit('OPEN_RESERVED_VARIABLE_LINK', item.url)}
						>
							{content}
						</Button>
					</li>
				);
			}

			if (item.url in (Store.get().appData?.pages || {})) {
				return (
					<li class={s[`${type}Wrapper`]} key={key}>
						<Button
							class={joinClasses(s[`${type}Link`], this.fontStyles[type === 'copyright' ? 'footerCopyright' : 'footerLegalLinks'])}
							trigger={() => Store.emit('CLOSE_AND_NAVIGATE', item.url, '', { instant: false })}
						>
							{content}
						</Button>
					</li>
				);
			}

			let Element = item.url ? Link : 'div';
			if (!item.url && item.openCookieConsentTool) {
				Element = 'button';
			}
			let attributes = {
				class: joinClasses(s[`${type}Link`], this.fontStyles[type === 'copyright' ? 'footerCopyright' : 'footerLegalLinks']),
				ariaLabel: item.ariaLabel,
				title: item.title,
				onClick: item.openCookieConsentTool ? this.openEvidon : () => this.onLinkClick(item)
			};
			if (item.url) {
				const disableNoOpNoRef = accessNested(this.props, 'data.defaultFooter.disableNoOpenerNoReferrer', false);
				attributes.href = item.url;
				attributes.target = item.target || (/^(https?:)?\/\//.test(item.url) ? '_blank' : '_self');
				attributes.rel = !disableNoOpNoRef && 'noopener noreferrer';
			}

			return (
				<li class={s[`${type}Wrapper`]} key={key}>
					<Element {...attributes}>{content}</Element>
				</li>
			);
		}));
	}

	renderExtra() {}

	render(props, state) {
		const {
			data,
			scrollElem,
			store,
			isHomeEntFooter
		} = props;

		const accessibilityCopy = accessNested(store, 'appData.copy.accessibilityCopy', {});
		// const isDesktop = accessNested(store, 'client.isDesktopSize');

		const copyright = accessNested(data, 'defaultFooter.copyright');

		const videosFooter = accessNested(store, 'header.videoOverlayOpen', false);
		const loneVideoDefaultFooter = videosFooter && this.isLoneVideoDefaultFooter();
		const stickyState = this.sticky || videosFooter;
		const staticAutoExpand = !this.sticky && accessNested(data, 'defaultFooter.autoExpand', false);
		const inlineFooter = !stickyState && accessNested(data, 'defaultFooter.inline', false);
		const signUpFormFooterLinks = accessNested(store, 'appData.options.formEmbeds.signUp.displayFooterLinks', false);

		const { ctaOpenCopy = 'FOOTER_CTA', ctaCloseCopy = 'FOOTER_CLOSE' } = data.defaultFooter || {};
		const toggleButtonText = state.open ? getCopy(ctaCloseCopy, {}, '', null, 'baseCopy') : getCopy(ctaOpenCopy, {}, '', null, 'baseCopy');
		const toggleButtonAria = state.open ? accessibilityCopy.$COLLAPSE_FOOTER_ARIA : accessibilityCopy.$EXPAND_FOOTER_ARIA;

		const isSinglePageIframed = getIsSinglePageIframed();

		const hidden = hideFooter();

		const style = {};
		if (!this.showtimesFooter && !this.hasTextPage && !this.pressKitFooter) {
			style.backgroundColor = state.backgroundColor;
		}

		const signUpOpen = accessNested(store, 'signupBanner.open', false);
		const signUpFormHeight = accessNested(Store.get(), 'client.signUpFormHeight', null);

		if (signUpOpen) {
			style.paddingBottom = signUpFormHeight
		}

		const activePage = store.activePage;
		const dedicatedIframePage = accessNested(store, ['appData', 'pages', activePage, 'page']) === 'iframe';

		const lastSectionId = sections[sections.length - 1]?.id;
		const hasWatchMoreShadow = lastSectionId === 'boltWatchMore' && !store.watchMore?.hide;
		const synopsisFooterShadow = store?.synopsis?.addShadowToFooter;
		const tiledItemsFooterShadow = store?.tiledItems?.addShadowToFooter;
		let needsShadow = (synopsisFooterShadow || tiledItemsFooterShadow || hasWatchMoreShadow) && !this.showtimesFooter;

		if (activePage === 'filmPage') {
			needsShadow = false;
		}

		const sonyFooter = accessNested(data, 'sonyFooter', false);
		const copy = accessNested(props, 'store.appData.copy', {});

		if (sonyFooter) {
			return (
				<footer
					data-section="boltFooter"
					style={style}
					class={joinClasses({
						s, wrapper: true,
						sticky: stickyState,
						open: state.open,
						showtimes: this.showtimesFooter,
						homeEnt: isHomeEntFooter,
						sidePanelOpen: accessNested(store, 'showtimes.show', false) || accessNested(store, 'homeEnt.show', false)
					})}
					role="contentinfo"
				>
					{needsShadow && <div class={s.shadow} />}
					<SonyFooter data={data.sonyFooter} showtimes={this.showtimesFooter} copy={copy} />
				</footer>
			);
		}

		if (activePage === 'boltHome') {
			const noSynopsisOrGallerySections = !sections.find(section => ['boltSynopsis', 'boltGallery'].includes(section.id));
			if (noSynopsisOrGallerySections) {
				style.backgroundColor = '';
			}
		}

		return (
			<footer
				data-section="boltFooter"
				style={style}
				class={joinClasses({
					s, wrapper: true,
					sticky: stickyState,
					open: state.open,
					showtimes: this.showtimesFooter,
					pressKit: this.pressKitFooter,
					homeEnt: isHomeEntFooter,
					sidePanelOpen: accessNested(store, 'showtimes.show', false) || accessNested(store, 'homeEnt.show', false),
					loneVideoDefaultFooter: loneVideoDefaultFooter,
					staticAutoExpand,
					inlineFooter,
					dedicatedIframePage,
					hidden,
					signUpFormFooterLinks
				})}
				role="contentinfo"
			>
				{needsShadow && <div class={s.shadow} />}
				<div class={joinClasses(s.outer, isSinglePageIframed && s.noLegalBtn)}>
					<Button
						class={s.scrollTop}
						trigger={() => smoothScrollTo(scrollElem || document.getElementById('mainScroll'), 0, 300)}
						ariaLabel={accessibilityCopy.$SCROLL_UP_ARIA}
					>
						<ArrowDown class={s.arrow} />
					</Button>
					{copyright && <ul class={s.copyright} key="copyright">{this.renderLinks(copyright, 'copyright')}</ul>}
					<div class={s.sizer} />
					<Button
						class={joinClasses(s.cta, this.fontStyles.footerLegalButton, isSinglePageIframed && s.hidden)}
						trigger={this.toggleFooter}
						key="toggle"
						ariaLabel={toggleButtonAria}
						ref={e => this.$cta = e}
					>
						{toggleButtonText}
					</Button>
				</div>
				<div class={s.openCropper}>
					{this.renderOpenFooter()}
					{inlineFooter && (
						<Button
							class={s.scrollTop}
							trigger={() => smoothScrollTo(scrollElem || document.getElementById('mainScroll'), 0, 300)}
							ariaLabel={accessibilityCopy.$SCROLL_UP_ARIA}
							key="inline-footer-scroll-top"
						>
							<ArrowDown class={joinClasses(s.arrow, s.arrowTop)} />
						</Button>
					)}
				</div>
				{this.renderExtra()}
			</footer>
		);
	}
}
